import { SEATING_STRATEGY_TYPE, SeatingStrategyBase } from "./seating-strategy";

export class SeatingStrategyPreferredSeating extends SeatingStrategyBase {
  constructor(matchScoreModifier, policyLevel) {
    super(SEATING_STRATEGY_TYPE.PreferredSeating, matchScoreModifier, 0, policyLevel);
  }

  static mediumPriority = { name: "Medium", value: 20 };
  static highPriority = { name: "High", value: 30 };
  static defaultValues() {
    return [
      SeatingStrategyPreferredSeating.mediumPriority,
      SeatingStrategyPreferredSeating.highPriority,
    ];
  }

  toString() {
    const label = this.matchScoreModifier == SeatingStrategyPreferredSeating.mediumPriority.value ?
      SeatingStrategyPreferredSeating.mediumPriority.name :
      SeatingStrategyPreferredSeating.highPriority.name;
    return `${SEATING_STRATEGY_TYPE.nameof(this.seatingStrategyType)} (${label} priority)`;
  }

  isValid() {
    return true;
  }

  static fromJSON(json){
    if(!json) return undefined;

    return Object.assign(new SeatingStrategyPreferredSeating(), json);
  }
}


